import type { CompassCopy, CompassLocale } from '../i18n';
import { COMPASS_LOCALE_STORAGE_KEY } from '../i18n';

export function readStoredLocale(): string | undefined {
  try {
    return window.localStorage.getItem(COMPASS_LOCALE_STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function LocaleSwitch(props: {
  locale: CompassLocale;
  copy: CompassCopy;
  onChange: (locale: CompassLocale) => void;
}): React.JSX.Element {
  const { locale, onChange } = props;
  return (
    <div className="flex items-center gap-1 p-1 bg-white/5 border border-white/10 rounded-full">
      <button 
        className={`px-4 py-1.5 rounded-full font-geist font-bold text-[10px] uppercase tracking-widest transition-all border-none cursor-pointer ${locale === 'zh-CN' ? 'bg-[#00ffff] text-[#030712]' : 'bg-transparent text-on-surface-variant hover:text-[#00ffff]'}`}
        onClick={() => onChange('zh-CN')}
      >
        中文
      </button>
      <button 
        className={`px-4 py-1.5 rounded-full font-geist font-bold text-[10px] uppercase tracking-widest transition-all border-none cursor-pointer ${locale === 'en' ? 'bg-[#00ffff] text-[#030712]' : 'bg-transparent text-on-surface-variant hover:text-[#00ffff]'}`}
        onClick={() => onChange('en')}
      >
        EN
      </button>
    </div>
  );
}
